import { AppCreatePage } from '@/features/access/pages/app/AppCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/app/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_app.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: AppCreatePage,
})
